import {CartDeliveryOption} from '@wix/delivery-section-cart/types';

export class DeliverySectionOptionModel {
  public id: string;
  public value: string;
  public subtitles: string[];
  public isSelectable: boolean;
  public isPartial: boolean;
  public hasTimeSlots: boolean;
  public isPickup: boolean;
  public pickupMethod: string;

  constructor(option: CartDeliveryOption) {
    this.id = option.options[0]?.id;
    this.value = option.title;
    this.subtitles = option.subtitles;
    this.isSelectable = true;
    this.isPartial = option.partial;
    this.hasTimeSlots = !!option.hasTimeSlots;
    this.isPickup = !!option.pickupDetails;
    this.pickupMethod = this.isPickup ? option.pickupDetails?.pickupMethod : undefined;
  }
}
